import { cn } from '../../lib/cn';

const SIZES = { 10: 'h-2.5 w-2.5', 12: 'h-3 w-3' } as const;

/**
 * A scheduling category's colour dot. Decorative: the category's name is always printed beside it, so
 * colour is never the only way to tell categories apart. The colour is content (the shared palette),
 * not a theme token, so it is drawn by inline style, never by a class.
 */
export function CategoryDot({
  color,
  size = 10,
  className,
}: {
  color: string;
  /** 10 in lists and pills, 12 beside a heading (as px at full size; drawn in rem). */
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block shrink-0 rounded-full', SIZES[size], className)}
      style={{ backgroundColor: color }}
    />
  );
}
